import React, { useState, forwardRef, useImperativeHandle } from 'react'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import OutlinedInput from '@mui/material/OutlinedInput'
import Checkbox from '@mui/material/Checkbox'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
const CompetitionDopNomination = forwardRef(({ defaultvar = [] }, ref) => {
  const [nominations, setNominations] = React.useState(defaultvar || [])
  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  const handleChangeNominations = (event) => {
    const {
      target: { value },
    } = event
    setNominations(typeof value === 'string' ? value.split(',') : value)
  }

  const currencies_nominations = [
    {
      value: '1',
      label: 'BIGFISH турнира',
    },
    {
      value: '2',
      label: 'BIGFISH суток',
    },
    {
      value: '3',
      label: 'Самая первая пойманная рыба',
    },
  ]

  const [error, setError] = useState('')
  const val = () => {
    return nominations
  }
  const validate = () => {
    if (nominations.length === 0) {
      setError('Продолжительность турнира обязательно')
      return false
    }
    setError('')
    return true
  }
  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))
  return (
    <FormControl variant="filled" fullWidth margin="none" error={!!error}>
      <InputLabel id="dop_nominationslabel">
        Дополнительные номинации
      </InputLabel>
      <Select
        labelId="dop_nominationslabel"
        id="dop_nominations"
        multiple
        value={nominations}
        onChange={handleChangeNominations}
        input={<OutlinedInput label="Дополнительные номинации" />}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={MenuProps}
      >
        {currencies_nominations.map((option, index) => (
          <MenuItem key={index} value={option.label}>
            <Checkbox checked={nominations.includes(option.label)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>

      <FormHelperText>Можно выбрать несколько</FormHelperText>
    </FormControl>
  )
})

export default CompetitionDopNomination
